// For showing admin-seeded HTML (magazine drafts in the console, editorial
// FAQ answers on the site): drops elements that run code or restyle the
// page, event-handler and style attributes, and javascript: URLs.
const UNSAFE_TAGS = "script, style, iframe, object, embed, link, meta, base, form, frame, frameset";
export function sanitizeHtml(html) {
  if (typeof html !== "string" || !html) return "";
  if (typeof DOMParser === "undefined") return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  doc.body.querySelectorAll(UNSAFE_TAGS).forEach((el) => el.remove());
  doc.body.querySelectorAll("*").forEach((el) => {
    Array.from(el.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = attr.value.replace(/[\s\u0000-\u001f]/g, "").toLowerCase();
      if (
        name.startsWith("on") ||
        name === "style" ||
        (["href", "src", "xlink:href", "action", "formaction", "srcset"].includes(name) &&
          (value.startsWith("javascript:") || value.startsWith("vbscript:") || value.startsWith("data:text")))
      ) {
        el.removeAttribute(attr.name);
      }
    });
    if (el.tagName === "A") {
      el.setAttribute("target", "_blank");
      el.setAttribute("rel", "noopener noreferrer");
    }
  });
  return doc.body.innerHTML;
}
